export default "__VITE_ASSET__DrZMy9eo__"